module.exports = __webpack_public_path__ + "static/media/icon-history.d78dcb3d.svg";